import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  cancelUpload,
  fetchUploadFile,
  fetchUploadList,
  reset,
  setPage,
} from 'features/bulk/upload/uploadSlice'
import { dateformat } from 'utils'
import { fail } from 'features/toast/Toast'
import Button from 'components/form/Button'
import Table from 'components/table/Table'
import NoneAnchor from 'components/NoneAnchor'
import Moment from 'react-moment'
import { BULK_STATUS, DOMAIN_TYPE, METHOD_TYPE } from 'features/bulk/BulkCodes'
import Pagination from 'components/pagination/Pagination'
import { useAlert } from 'features/dialog/Alert'
import {
  hideUploadModal,
  showUploadModal,
} from 'features/bulk/upload/uploadModalSlice'
import UploadModal from './UploadModal'

const Upload = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    content,
    totalElements,
    page,
    size,
    disabledCancel,
    disabledDownload,
  } = useSelector(state => state.bulk.upload)
  const [FailedAlert, showFailedAlert] = useAlert()

  useEffect(() => {
    dispatch(fetchUploadList())
  }, [dispatch, page])

  useEffect(
    () => () => {
      dispatch(reset())
      dispatch(hideUploadModal())
    },
    [dispatch]
  )

  const showModal = () => {
    dispatch(showUploadModal())
  }

  const handleRefresh = () => {
    dispatch(fetchUploadList())
  }

  const handlePageChange = v => dispatch(setPage(v))

  const handleCancelUpload = async id => {
    const { error, payload } = await dispatch(cancelUpload(id))
    if (error) {
      fail(payload.errorMessage)
    }
    dispatch(fetchUploadList())
  }

  const handleFileDownload = async id => {
    const { error, payload } = await dispatch(fetchUploadFile(id))
    if (error) {
      fail(payload.errorMessage)
    } else {
      window.open(`${payload.url}&download`)
    }
  }

  return (
    <>
      <ul className="list_append">
        <li>
          업로드 메뉴를 통해 대량의 키워드와 소재 등을 등록하거나 입찰가,
          일예산, ON/OFF 상태 등을 대량변경 하실 수 있습니다.
        </li>
        <li>
          대량 관리를 통한 작업 시간은 사용량과 데이터 크기에 따라 유동적일 수
          있으며, 대량 관리 내역은 최근 3개월까지만 제공합니다.
        </li>
      </ul>
      <div className="ad_managebox">
        <div className="managebox_tit">
          <strong className="tit_box">
            총 업로드 목록 <em className="fc_emph">{totalElements}</em>
          </strong>
          <div className="f_left">
            <Button primary onClick={showModal}>
              <span className="img_comm ico_add" />
              업로드 등록하기
            </Button>
          </div>
          <div className="f_right">
            <Button line onClick={handleRefresh} disabled={isLoading}>
              새로고침
            </Button>
          </div>
        </div>
        <div className="tblg2_wrap">
          <Table
            className="tbl_g2"
            caption="업로드 목록 표"
            loading={isLoading}
            emptyMessage={
              <>
                등록된 업로드 목록이 없습니다.
                <br />
                <NoneAnchor className="link_txt" onClick={showModal}>
                  업로드 등록하기
                </NoneAnchor>
                를 클릭하여 새로운 업로드 유형을 생성하세요.
              </>
            }>
            <Table.Head>
              <Table.Column title="등록일시" width={153} />
              <Table.Column title="유형" width={157} />
              <Table.Column title="파일명" />
              <Table.Column title="처리자" width={249} />
              <Table.Column title="상태" width={130} />
              <Table.Column title="완료일시" width={145} />
              <Table.Column title="처리결과" width={85} className="align_c" />
            </Table.Head>
            <Table.Body>
              {content.map(
                ({
                  id,
                  name,
                  actor,
                  fileUrl,
                  domainType,
                  methodType,
                  status,
                  createdDate,
                  processedDate,
                }) => (
                  <Table.Row key={id} rowId={id}>
                    <td>
                      <div className="inner_tbl">
                        <Moment format={dateformat}>{createdDate}</Moment>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        [{METHOD_TYPE[methodType].text}]
                        {DOMAIN_TYPE[domainType].text}
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <a href={`${fileUrl}&download`} className="limit_line">
                          {name}
                        </a>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">{actor}</div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <p className="ad_state">
                          <span className={`ico_${BULK_STATUS[status].icon}`}>
                            DOWNLOAD_STATUS[status].icon
                          </span>
                          {BULK_STATUS[status].text}
                          {status === BULK_STATUS.WAITING.name && (
                            <Button
                              line
                              size="small"
                              onClick={() => handleCancelUpload(id)}
                              disabled={disabledCancel}>
                              취소
                            </Button>
                          )}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {processedDate && (
                          <Moment format={dateformat}>{processedDate}</Moment>
                        )}
                      </div>
                    </td>
                    <td className="align_c">
                      <div className="inner_tbl">
                        <div className="wrap_btn">
                          {status === BULK_STATUS.PARTIAL_FAILED.name && (
                            <Button
                              size="small"
                              disabled={disabledDownload}
                              onClick={() => {
                                handleFileDownload(id)
                              }}>
                              다운로드
                            </Button>
                          )}
                          {status === BULK_STATUS.TOTAL_FAILED.name && (
                            <Button size="small" onClick={showFailedAlert}>
                              내역보기
                            </Button>
                          )}
                        </div>
                      </div>
                    </td>
                  </Table.Row>
                )
              )}
            </Table.Body>
          </Table>
        </div>
        {totalElements > 0 && (
          <div className="paging_wrap">
            <div className="inner_paging">
              <Pagination
                current={page}
                total={totalElements}
                size={size}
                onChange={handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
      <UploadModal />
      <FailedAlert title="실패 내역 보기">
        사용불가 문자 등록 또는 시스템 이슈로 파일 업로드가 실패하였습니다.
        <br />
        업로드 파일 검토 후 재요청 바랍니다.
      </FailedAlert>
    </>
  )
}
export default Upload
